import { render, staticRenderFns } from "./FormSwitcher.vue?vue&type=template&id=c9d24230&scoped=true"
import script from "./FormSwitcher.vue?vue&type=script&lang=js"
export * from "./FormSwitcher.vue?vue&type=script&lang=js"
import style0 from "./FormSwitcher.vue?vue&type=style&index=0&id=c9d24230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d24230",
  null
  
)

export default component.exports